import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})


export class ActionContactWithService extends GenericService<any>{

    constructor(private http: HttpClient) {
        super(http,'/ContactWith/', environment.Services.AlphaURLSlot2)
    }
    
}